module.exports = {

  user_troubleshooting_tab_title: "Resolución de Problemas de Usuario",
  user_troubleshooting_tab_filter_by_last: "Más recientes",
  user_troubleshooting_tab_filter_by_date: "Entre",
  user_troubleshooting_tab_apply_filters: "Aplicar",

  user_troubleshooting_tab_date_range: "Por favor seleccione un rango de fechas valido",
  user_troubleshooting_tab_raw_message: "Mensaje sin Procesar",

  user_troubleshooting_tab_warning: "Advertencia",
  user_troubleshooting_tab_created_on: "Creación",
  user_troubleshooting_installed: "Instalada",
  user_troubleshooting_sim_status: "Estado de la SIM",
  user_troubleshooting_gps: "GPS",
  user_troubleshooting_tab_details: "Detalles",
  user_troubleshooting_tab_passed: "Paso",
  user_troubleshooting_tab_fail: "Fallo",
  user_troubleshooting_odo_engine: "Odometro/Horas Motor"
}
